import React from "react";
import { useLanguage } from "../../localization/LanguageContext";
import "./StatusBadge.css";

const joinClasses = (...values) => values.filter(Boolean).join(" ");

export function StatusBadge({
  children,
  tone = "neutral",
  dot = false,
  className = "",
  ...rest
}) {
  const { copy } = useLanguage();
  const label = typeof children === "string" ? copy(children) : children;
  return (
    <span
      className={joinClasses("crm-status-badge", className)}
      data-tone={tone}
      {...rest}
    >
      {dot && <span className="crm-status-badge__dot" aria-hidden="true" />}
      <span>{label}</span>
    </span>
  );
}
